import React from 'react';
import { useNavigate } from 'react-router-dom';

const WebOnlyNotice = ({ message, backTo = '/driver/dashboard', backLabel = 'Back to Dashboard' }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-lg mx-auto p-6 mt-12">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-8 text-center">
        <svg className="w-12 h-12 mx-auto mb-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        <p className="text-gray-700 text-lg font-medium mb-6">{message}</p>
        <button
          onClick={() => navigate(backTo)}
          className="inline-flex items-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          {backLabel}
        </button>
      </div>
    </div>
  );
};

export default WebOnlyNotice;
